import { Component, inject, input, signal } from '@angular/core';
import { Image } from '../../apartment/header/header.component';
import { NewsletterInputFieldComponent } from '../newsletter/newsletter-input-field/newsletter-input-field.component';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { UmamiService } from '../../../services/umami.service';

@Component({
    selector: 'app-newsletter-popup',
    imports: [NewsletterInputFieldComponent],
    host: { class: 'fixed z-[100]' },
    templateUrl: './newsletter-popup.component.html',
})
export class NewsletterPopupComponent {
    data = input.required<NewsletterPopup>();
    isPopupActive = signal(false);
    domHandler = inject(DOMHandlerService);
    umami = inject(UmamiService);

    constructor() {
        const onScroll = () => {
            setTimeout(() => {
                this.showPopup();
            }, this.data().popupAfterSeconds * 1000);
            window.removeEventListener('scroll', onScroll);
        };

        window.addEventListener('scroll', onScroll);
    }

    hidePopup() {
        this.isPopupActive.set(false);
    }

    showPopup() {
        this.isPopupActive.set(true);
    }
}

type NewsletterPopup = {
    title: string;
    subTitle: string;
    popupAfterSeconds: number;
    newsletterPopupImage: Image;
};
